import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import businessModelActions from '../actions/businessModel';

function getPreferredBusinessModel(store, action) {
    const { systemId, advertiserId } = action.payload;

    const queryParams = new URLSearchParams({ systemId });
    if (typeof advertiserId !== 'undefined') {
        queryParams.append('advertiserId', advertiserId);
    }

    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?${queryParams.toString()}`)
        .end((error, response) => {
            store.dispatch(actions.enableLoadOverLay(false));

            if (error) {
                store.dispatch(businessModelActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const res = JSON.parse(response.text);
                const businessModelType = res.businessModel;
                store.dispatch(businessModelActions.getPreferredBusinessModelSuccess(businessModelType));
            } catch (exp) {
                store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default getPreferredBusinessModel;
